import { CellComment } from '@datasets/utils/dataset-utils'
import { DatasetWithDatasetRows } from '@global/types'

export type SelectedRows = Record<string, ReadGridRow | number>

export interface ReadGridRow {
  data: ReadGridData
  cvid: string
}

type ReadGridData = Record<string, ReadGridDataValue>

interface ReadGridDataError {
  errorCode: number
  errorData: Record<string, unknown>
  defaultErrorMsg: string
}

interface ReadGridDataValue {
  value: string
  errors?: ReadGridDataError[]
  comments?: CellComment[]
}

export interface State {
  bulkUploadModalIsOpen: boolean
  bulkResubmitModalIsOpen: boolean
  datasetDataId: string | null
  selectedCell: string | null
  selectedCells: object
  selectedRows: SelectedRows
  manualEdit: boolean
  manualEditCanSubmitAll: boolean
  manualEditLoading: boolean
  selectiveEditDatasetsById: Record<string, DatasetWithDatasetRows> | null
  selectiveEditModeEnabled: boolean
  datasetTemplateId: null | number
  removingRows: boolean
  rowMode: string
}

export const ActionType = {
  selectedRows: 'selectedRows',
  editMode: 'editMode',
  datasetTemplateId: 'datasetTemplateId',
  setDatasetDataId: 'setDatasetDataId',
  setSelectedCell: 'setSelectedCell',
  setSelectedCells: 'setSelectedCells',
  setSelectedRows: 'setSelectedRows',
  setModal: 'setModal',
  setManualEditLoading: 'setManualEditLoading',
  setRowMode: 'setRowMode',
  manualEditRows: 'manualEditRows',
  closeManualEdit: 'closeManualEdit',
  closeSelectiveDataset: 'closeSelectiveDataset',
  removeRows: 'removeRows',
} as const

export type ActionType = (typeof ActionType)[keyof typeof ActionType]

export type Action =
  | { type: typeof ActionType.selectedRows; payload: { data: SelectedRows } }
  | { type: typeof ActionType.editMode; payload: { isEnabled: boolean } }
  | { type: typeof ActionType.datasetTemplateId; payload: { id: number } }
  | { type: typeof ActionType.setDatasetDataId; payload: string }
  | { type: typeof ActionType.setSelectedCell; payload: string }
  | { type: typeof ActionType.setSelectedCells; payload: object }
  | { type: typeof ActionType.setSelectedRows; payload: SelectedRows }
  | {
      type: typeof ActionType.setModal
      payload: {
        bulkUploadOpen?: boolean
        resubmitOpen?: boolean
      }
    }
  | { type: typeof ActionType.setManualEditLoading; payload: { loading: boolean } }
  | { type: typeof ActionType.setRowMode; payload: string }
  | {
      type: typeof ActionType.manualEditRows
      payload: {
        canSubmitAll: boolean
        datasetStructuresByDatasetId: Record<string, DatasetWithDatasetRows>
      }
    }
  | { type: typeof ActionType.closeManualEdit }
  | { type: typeof ActionType.closeSelectiveDataset }
  | { type: typeof ActionType.removeRows; payload: { removingRows: boolean } }
